module.exports = __webpack_public_path__ + "img/4.6f20cc52.png";